<app-header *ngIf="showHeader"></app-header>

<div class="app-shell" *ngIf="showHeader; else noShell">
  <app-sidebar *ngIf="showSidebar" (expandedChange)="onSidebarExpanded($event)"></app-sidebar>
  <main class="main-content" [class.with-sidebar]="showSidebar" [class.sidebar-expanded]="sidebarExpanded">
    <router-outlet></router-outlet>
  </main>
</div>

<ng-template #noShell>
  <router-outlet></router-outlet>
</ng-template>

<app-dialog id="changeNext"></app-dialog>
<app-dialog id="aviso"></app-dialog>
<app-dialog id="avisoEnd"></app-dialog>
<app-loader></app-loader>
